export enum ElementKind {
  /// <summary>
  /// حکمی
  /// </summary>
  EmploymentOrder = 1,
  /// <summary>
  /// محاسباتی
  /// </summary>
  Computational = 2,
  /// <summary>
  /// فرم ورودی
  /// </summary>
  InputForm = 3,
  /// <summary>
  /// مانده مرخصی
  /// </summary>
  LeaveRemain = 4,
}
